import { STATS_STATUS } from "@/constants";

export default {
  query: null,
  logs: [],
  status: STATS_STATUS.NOT_ASKED,
  error: null
};
